<div class="dialog-content-max">
    <form [formGroup]="supportloginform">
        <div  class="formgrid grid">
            <div class="field col-12">
 <label for="organisation">Organisation<span style="color: rgb(222, 30, 30); font-weight: bold;">*</span></label>
                <p-dropdown [options]="orglist" inputId="organisation" [filter]="true" appendTo="body" name="organisation"
                    optionLabel="name" optionValue="orgid" placeholder="Select Organisation" formControlName="organisation"></p-dropdown>
                      <span style="color:red" *ngIf="supportloginform.get('organisation').invalid && supportloginform.get('organisation').touched">
                    {{getErrorMessage(supportloginform, validation_message, 'organisation')}}
                </span>  

            </div>
        </div>
        <div class="formgrid grid">
            <div class="field col-12">
                <label for="name">Email ID <span style="color: rgb(222, 30, 30); font-weight: bold;">*</span></label>
                <input type="text" class="form-control" id="userid" placeholder="Enter user name"
                            name="userid" formControlName="userid">
                         <span style="color:red" *ngIf="supportloginform.get('userid').invalid && supportloginform.get('userid').touched">
                    {{getErrorMessage(supportloginform, validation_message, 'userid')}}
                </span>  
            </div>

        </div>

        <div class="formgrid grid">
            <div class="field col-12">
                                <label for="activeflag">Password <span style="color: rgb(222, 30, 30); font-weight: bold;">*</span></label>
                  <input type="password" class="form-control" id="password" placeholder="Enter password"
                            name="password" formControlName="password">    
                <span style="color:red" *ngIf="supportloginform.get('password').invalid && supportloginform.get('password').touched">
                    {{getErrorMessage(supportloginform, validation_message, 'password')}}
                </span>    
            </div>
        </div>

       
    </form>

    <div class="custom-dialog-footer">
        <p-button class="m-1" label="Cancel" styleClass="customeclose" (click)="dismiss()"></p-button>

        <p-button class="m-1" label="Login" styleClass="customesave" 
        (click)="login()" 
        [disabled]="supportloginform.invalid"> <!-- Disable button if form is invalid or name is empty -->
    </p-button> </div>
</div>
